import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { Institution } from 'search'

import styles from './index.css'

class InstitutionsList extends PureComponent {
  render() {
    const { className, institutions } = this.props

    return (
      <div className={classnames(styles.wrapper, className)}>
        <div className="grid grid-cols-1 640:grid-cols-2 1024:grid-cols-3 gap-1 p-2 bg-white">
          {institutions.map((institution) => (
            <Institution key={institution.id} institution={institution} />
          ))}
        </div>
      </div>
    )
  }
}

InstitutionsList.propTypes = {
  className: PropTypes.string,
  institutions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      avatar: PropTypes.object,
      name: PropTypes.string,
    }),
  ).isRequired,
}

InstitutionsList.defaultProps = {
  className: null,
}

export default InstitutionsList
